/**
 * Soru görsellerini Firebase Storage'a yükleme.
 * questionBankService'ten ayrı: o modül tüm derslerin soru repository'lerini (~5 MB) statik import ediyor;
 * userService (dolayısıyla App ve landing sayfası) sadece bu iki fonksiyona ihtiyaç duyuyor.
 */
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, isFirebaseActive } from './firebase';
import { SubjectType } from '../types';

/** Görsel dosyayı Storage'a yükle, URL döndür */
export async function uploadQuestionImage(
    subject: SubjectType,
    imageBlob: Blob,
    filename: string
): Promise<string | null> {
    if (!isFirebaseActive || !storage) return null;
    // 1. Önce tüm giriş yapmış kullanıcılara (öğrenci & admin) açık olan ai_generated_images klasörünü dene
    try {
        const aiRef = ref(storage, `ai_generated_images/${subject}_${Date.now()}_${filename}`);
        await uploadBytes(aiRef, imageBlob);
        const url = await getDownloadURL(aiRef);
        console.log(`%c[Storage] Görsel başarıyla yüklendi (ai_generated_images) → ${url}`, 'color:#22c55e');
        return url;
    } catch (e1) {
        console.warn('[uploadQuestionImage] ai_generated_images denendi, question_images fallback yapılıyor:', e1);
        try {
            const storageRef = ref(storage, `question_images/${subject}/${Date.now()}_${filename}`);
            await uploadBytes(storageRef, imageBlob);
            const url = await getDownloadURL(storageRef);
            console.log(`%c[Storage] Görsel başarıyla yüklendi (question_images) → ${url}`, 'color:#22c55e');
            return url;
        } catch (e2) {
            console.error('uploadQuestionImage error:', e2);
            return null;
        }
    }
}

/** Base64 görsel → Storage'a yükle */
export async function uploadBase64Image(subject: SubjectType, base64Data: string): Promise<string | null> {
    try {
        // base64'ten blob oluştur
        const byteString = atob(base64Data.split(',')[1] || base64Data);
        const mimeType = base64Data.includes('data:')
            ? base64Data.split(';')[0].split(':')[1]
            : 'image/png';
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeType });
        return await uploadQuestionImage(subject, blob, `ai_generated_${Date.now()}.png`);
    } catch (e) {
        console.error('uploadBase64Image error:', e);
        return null;
    }
}
